// extracted by mini-css-extract-plugin
export default {"row":"tableRow_row__gHwx9","td":"tableRow_td__L-vNX","cell":"tableRow_cell__LIuAk"};